import {
  Button, Flex, Input, Typography
} from 'antd';
import React from 'react';
import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';

import { TableForm } from '.';

export type ButtonCheck = {
  isShow?: boolean;
  onHandleCheck?: (id: string) => void;
};

interface FormIdentitfyProps {
  method: UseFormReturn<TableForm>;
  buttonRecheck?: ButtonCheck;
  onHandlePressEnter?: () => void;
}
const FormIdentitfy: React.FC<FormIdentitfyProps> = ({
  method, buttonRecheck, onHandlePressEnter
}) => {
  const { isDirty } = method.formState;
  return (
    <>
      <Typography.Text>
        Số CCCD
      </Typography.Text>
      <FormProvider {...method}>
        <Controller
          name="idCardNumber"
          control={method.control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              <Flex gap={12} align="center" style={{ marginTop: 8 }}>
                <Input
                  value={value}
                  onChange={onChange}
                  size="large"
                  placeholder="Số CCCD"
                  onPressEnter={() => {
                    if (buttonRecheck && buttonRecheck.onHandleCheck) {
                      buttonRecheck.onHandleCheck(value);
                    } else if (onHandlePressEnter) {
                      onHandlePressEnter();
                    }
                  }}
                />
                {
                  buttonRecheck && (
                    <Button
                      type="primary"
                      size="large"
                      disabled={!isDirty}
                      onClick={() => {
                        if (buttonRecheck.onHandleCheck) {
                          buttonRecheck.onHandleCheck(value);
                        }
                      }}
                    >
                      <Typography.Text style={{ color: 'white' }}>
                        Kiểm tra CCCD
                      </Typography.Text>
                    </Button>
                  )
                }
              </Flex>
              {(error?.message || (buttonRecheck && isDirty)) && (
                <div style={{ marginTop: 6 }}>
                  <Typography.Text type="danger">
                    {error?.message || (buttonRecheck && isDirty ? 'Bạn đã thay đổi CCCD, vui lòng nhấn kiểm tra CCCD để xác nhận thông tin đăng ký' : '')}
                  </Typography.Text>
                </div>
              )}
            </>
          )}
        />
      </FormProvider>
    </>
  );
};

export default FormIdentitfy;
